import React from 'react';
import { motion } from 'framer-motion';
import './Features.css';

// Import your icons from assets
import priceIcon from '../../Assets/Features/money 1.png';
import timeIcon from '../../Assets/Features/activity 1.png';
import dealIcon from '../../Assets/Features/security (1) 1.png';
import teamIcon from '../../Assets/Features/worker 1.png';

const featureData = [
  {
    id: 1,
    icon: priceIcon,
    title: "Market leading prices",
    desc: "We offer high-quality insulation solutions at competitive and value-driven pricing."
  },
  {
    id: 2,
    icon: timeIcon,
    title: "Timely Completion of Orders",
    desc: "We ensure every project and supply order is delivered within the committed timeframe without compromising quality."
  },
  {
    id: 3,
    icon: dealIcon,
    title: "Transparent Business Dealings",
    desc: "We maintain clear communication, honest pricing & complete transparency at every stage of the process."
  },
  {
    id: 4,
    icon: teamIcon,
    title: "Qualified and Trained Team of Professionals",
    desc: "Our experienced team is skilled in handling industrial insulation projects with precision and technical expertise."
  }
];

const Features = () => {
  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.6, ease: "easeOut" } 
    }
  };

  return (
    <section className="features-section">
      <div className="features-container">
        <motion.h2 
          className="features-title"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          Delivering Performance <br /> <span>With Reliability</span>
        </motion.h2>

        <motion.div 
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {featureData.map((item) => (
            <motion.div key={item.id} className="feature-card" variants={cardVariants}>
              <div className="card-inner">
                <div className="icon-wrapper">
                  <img src={item.icon} alt={item.title} className="feature-icon" />
                </div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;